<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="mb-base" :title="$t('carta.NuevaCarta')" >
          <new-carte></new-carte>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
    import NewCarte from '../components/Cartes/NewCarte';
    export default {
        components: {
            NewCarte
        },
        data () {
            return {
            }
        }
    }

</script>

<style>

</style>
